var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.name)+" "),(_vm.helpTip)?_c('Tooltip',{attrs:{"label":_vm.helpTip}},[_c('i',{staticClass:"far fa-info-circle text-muted"})]):_vm._e()],1),_c('td',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }